export default __webpack_public_path__ + "static/media/support.5cf06229.svg";